const accordionInstances = [];

class Accordion {
    constructor(domNode) {
        this.rootEl = domNode;
        this.buttonEl = this.rootEl.querySelector('button[aria-expanded]');

        if(!this.buttonEl) {
            return;
        }

        const controlsId = this.buttonEl.getAttribute('aria-controls');
        const buttonId = this.buttonEl.getAttribute('id');
        
        this.contentEl = document.getElementById(controlsId);
        this.open = this.buttonEl.getAttribute('aria-expanded') === 'true';

        this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));

        this.scrollToCurrent(buttonId);

        accordionInstances.push(this);
    }

    onButtonClick() {
        this.toggle(!this.open);
    }

    toggle(open) {
        if (open === this.open) {
            return;
        }

        this.open = open;

        this.buttonEl.setAttribute('aria-expanded', `${open}`);
        if (open) {
            this.contentEl.removeAttribute('hidden');
        } else {
            this.contentEl.setAttribute('hidden', '');
        }
    }

    open() {
        this.toggle(true);
    }

    close() {
        this.toggle(false);
    }

    scrollToCurrent(buttonId) {
        if (window.location.href.includes('#')) {
            const anchorLink = window.location.href.split('#')[1];

            if (anchorLink === buttonId) {
                this.toggle(true)
                document.getElementById(buttonId).scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    }
}

function initAccordions(accordions) {
    accordions.forEach((accordionEl) => {
        new Accordion(accordionEl);
    });
}

// init accordions
const accordions = document.querySelectorAll('.accordion h3');
if (accordions) {
    initAccordions(accordions);

    const isBackend = document.querySelector('.neos-backend');

    if (isBackend) {
        handleBackendAccordion();
    }
}

function closeAllExcept(exceptAccordion) {
    accordionInstances.forEach(accordion => {
        if (accordion !== exceptAccordion || accordion.open) {
            accordion.toggle(false);
        }
    });
}

function handleBackendAccordion() {
    const focusClass = 'TnLEVq_markActiveNodeAsFocused--focusedNode';

    document.addEventListener('click', (event) => {
        const accordionContainer = event.target.closest('.accordion');
        
        const hasFocus = () => {
            if (!accordionContainer) {
                return false;
            }

            if (accordionContainer.classList.contains(focusClass)) {
                return true;
            }
        };

        if (hasFocus()) {
            const element = accordionContainer.querySelector('h3');
            
            if (element) {
                const accordionInstance = accordionInstances.find(
                    acc => acc.rootEl === element
                );

                if (accordionInstance) {
                    closeAllExcept(accordionInstance);
                    accordionInstance.toggle(true);
                }
            }
        }
    })
}
